import numeral from 'numeral';
import { useStore } from '../../store';

export const ProductMinimumPrice: React.FC<{}> = props => {
  const minimumPrice = useStore(s => s.minimumPrice());

  return <span>{numeral(minimumPrice).format('$ 0,0.00')}/unit</span>;
};
